'use client';
import { useState } from 'react';

export const ColorGroup = ({ data }) => {
    const [selected, setSelected] = useState(0);

    if (!data || data.length === 0) return null;

    const active = data[selected];

    return (
        <div style={{
            background: '#fff',
            border: '1px solid rgba(11,49,99,0.14)',
            borderRadius: '10px',
            padding: '10px 14px',
            marginTop: '10px',
        }}>
            <div className="flex flex-row flex-wrap lg:flex-column align-items-center lg:align-items-start gap-2">
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }} className="lg:mb-2">
                    <span style={{ fontSize: '0.72rem', fontWeight: 700, color: 'var(--primary-color)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                        Available Colors
                    </span>
                    {active?.color && (
                        <span style={{
                            display: 'inline-block',
                            width: 18, height: 12,
                            borderRadius: '3px',
                            background: active.color,
                            border: '1px solid rgba(0,0,0,0.15)',
                            flexShrink: 0,
                        }} />
                    )}
                    <span className="text-primary" style={{ fontSize: '0.75rem', fontWeight: 600 }}>
                        {active?.title}
                    </span>
                </div>

            <div style={{ display: 'flex', gap: '8px', flexWrap: 'nowrap', alignItems: 'center', overflowX: 'auto' }}>
                {data.map((c, i) => (
                    <button
                        key={c._id || i}
                        onClick={() => setSelected(i)}
                        title={c.title}
                        style={{
                            width: 36, height: 22,
                            borderRadius: '4px',
                            background: c.color,
                            border: i === selected
                                ? '2.5px solid var(--primary-color)'
                                : '2px solid rgba(0,0,0,0.12)',
                            outline: i === selected ? '2px solid rgba(11,49,99,0.2)' : 'none',
                            outlineOffset: 2,
                            cursor: 'pointer',
                            flexShrink: 0,
                            boxShadow: i === selected ? '0 2px 8px rgba(11,49,99,0.18)' : 'none',
                            transition: 'transform 0.12s',
                            transform: i === selected ? 'scale(1.12)' : 'scale(1)',
                            padding: 0,
                        }}
                    />
                ))}
            </div>
            </div>
        </div>
    );
};
